import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LocationModel} from "../../../models/location.model";
import {LocationHolderType} from "../../../types/locationHolder.type";

@Injectable({providedIn: 'root'})
export class LocationsHttpService {

  private base_url = `/location`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getLocations(payload: {holderId: string, holder: LocationHolderType}[]): Observable<any> {
    return this.http
      .post<any>(this.base_url, payload);
  }

  getLocation(holderId: string, holder: LocationHolderType ): Observable<LocationModel> {
    return this.http.get<LocationModel>(`${this.base_url}/${holder}/${holderId}`);
  }

}
